import { Grid, Typography } from '@material-ui/core/';
import withStyles from '@material-ui/core/styles/withStyles';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import {
  fetchEnd,
  fetchStart,
  RadioButtonGroupInput,
  ReferenceInput,
  required,
  SelectInput,
  TextInput
} from 'react-admin';
import { FormSpy } from 'react-final-form';
import { isFieldContainsOnlySpaces } from '../../core/utils/index';

import dataProvider from '../../../src/core/providers/IccUserDataProvider';
import DocumentPresetApi from '../../core/apis/DocumentPresetApi';
import FieldTitleWithListPopover from '../../core/components/inputs/FieldTitleWithListPopover';

import { useFormState, useForm } from 'react-final-form';
import { batchTitleVariables } from '../resourceuploads/ResourceUploadLookups';
import toArray from 'lodash/toArray';
import useNotifyServerError from '../../core/hooks/useNotifyServerError';

const styles = {
  headerContainer: {
    paddingTop: '0px !important'
  },
  formCheckBox: {
    marginTop: '19px'
  },
  label: {
    fontSize: '14px',
    color: '#757575',
    paddingLeft: '2px',
    transform: 'translate(0px, 5px)'
  },
  inputLabel: {
    width: '100%'
  }
};

const translateWatermarkInputToRecord = v => {
  if (v === -1) {
    return null;
  }
  return v;
};

const translateWatermarkRecordToInput = v => {
  if (v === null) {
    return -1;
  }
  return v;
};

const WatermarkSelectInput = props => {
  let defaultProfile = {
    id: -1,
    profileName: 'Default Profile'
  };
  let customChoices = [];

  customChoices.push(defaultProfile);
  customChoices = customChoices.concat(props.choices);

  return (
    <SelectInput
      label="Watermark Profile"
      choices={customChoices}
      optionText="profileName"
      source={props.source}
      variant={props.variant}
      perPage={-1}
      sort={{ field: 'profileName', order: 'ASC' }}
      parse={translateWatermarkInputToRecord}
      format={translateWatermarkRecordToInput}
    />
  );
};

const whenFieldChanges = (field, becomes, set, to, formProps) => {
  if (
    formProps &&
    formProps.values &&
    (!becomes || formProps.values[field] === becomes)
  ) {
    formProps.form.change(set, to);
  }
};

const PresetSummary = props => {
  const [hasSubcategories, setHasSubcategories] = useState(false);
  const [hasWatermark, setHasWatermark] = useState(false);
  const [subcategories, setSubcategories] = useState([]);
  const [formErrors, setFormErrors] = useState([]);

  const formState = useFormState();
  const form = useForm();
  const resourceUploadTitleRef = useRef(null);
  const notifyServerError = useNotifyServerError();

  const { record } = props;

  const onCategoryChange = useCallback(
    (categoryId, formProps) => {
      // reset subCategoryId field
      whenFieldChanges(
        'categoryId',
        undefined,
        'subCategoryId',
        undefined,
        formProps
      );

      fetchStart();
      const crudOperation = 'GET_LIST';
      dataProvider(crudOperation, 'subcategories', {
        pagination: { page: 1, perPage: -1 },
        sort: { field: 'name', order: 'DESC' },
        filter: { categoryId: categoryId }
      })
        .then(({ data }) => {
          if (data) {
            var subCats = data.filter(subcat => subcat.name !== '');
            if (subCats.length > 0) {
              setHasSubcategories(true);
              setSubcategories(subCats);
            } else {
              setHasSubcategories(false);
              setSubcategories(undefined);
            }
          }
        })
        .catch(notifyServerError)
        .finally(() => {
          // Dispatch an action letting react-admin know a API call has ended
          fetchEnd();
        });
    },
    [notifyServerError]
  );

  useEffect(() => {
    record && record.watermarkProfileId && setHasWatermark(true);
    if (record && record.documentSecurityId) {
      fetchStart();
      const crudOperation = 'GET_ONE';
      dataProvider(crudOperation, 'documentsecurities', {
        id: record.documentSecurityId
      })
        .then(({ data }) => {
          if (data && data.applyWatermark) {
            setHasWatermark(true);
          } else {
            setHasWatermark(false);
          }
        })
        .catch(notifyServerError)
        .finally(() => {
          // Dispatch an action letting react-admin know a API call has ended
          fetchEnd();
        });
    }
    record && record.categoryId && onCategoryChange(record.categoryId);
  }, [record, notifyServerError, onCategoryChange]);

  /*
   * Verify that Preset Name is unique
   */
  const validatePresetName = async (value, allValues, props) => {
    if (props.record && value === props.record.presetName) {
      return;
    }

    if (props.active) {
      let error;
      const nameExists = await DocumentPresetApi.checkNameExists(value);

      if (nameExists) {
        error = 'Document profile with this name already exists';
      } else {
        error = undefined;
      }

      setFormErrors({ ...formErrors, name: error });
      return error;
    }
    return formErrors.name;
  };

  const onSecurityChange = useCallback(
    (securityId, formProps) => {
      // reset watermarkProfileId field
      whenFieldChanges(
        'documentSecurityId',
        undefined,
        'watermarkProfileId',
        undefined,
        formProps
      );

      fetchStart();
      const crudOperation = 'GET_ONE';
      dataProvider(crudOperation, 'documentsecurities', { id: securityId })
        .then(({ data }) => {
          if (data && data.applyWatermark) {
            setHasWatermark(true);
          } else {
            setHasWatermark(false);
          }
        })
        .catch(notifyServerError)
        .finally(() => {
          // Dispatch an action letting react-admin know a API call has ended
          fetchEnd();
        });
    },
    [notifyServerError]
  );

  const onUploadTypeChange = (splitType, formProps) => {
    // reset splitMethodId field
    whenFieldChanges(
      'uploadType',
      undefined,
      'splitMethodId',
      undefined,
      formProps
    );
  };

  const handleSelectVariableBatchTitle = variable => {
    let currentValue = toArray(formState.values.resourceUploadTitle || '');
    const cursorIndex = resourceUploadTitleRef.current.selectionStart || 0;
    currentValue.splice(cursorIndex, 0, variable.value);

    form.change('resourceUploadTitle', currentValue.join(''));
  };

  const { classes, variant, resource } = props;

  const myrequired = (at1, at2, at3) => {
    return required()(at1, at2, at3);
  };

  return (
    <FormSpy>
      {formProps => {
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} className={classes.headerContainer}>
              <Typography variant="h5">Document Profile Details</Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <TextInput
                source="presetName"
                label="Document Profile Name"
                validate={[
                  myrequired,
                  isFieldContainsOnlySpaces,
                  validatePresetName
                ]}
                options={{ autoComplete: 'off' }}
                variant={variant}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <ReferenceInput
                source="categoryId"
                resource=""
                reference="categories"
                label="Document Category"
                filter={{ subType: 'REPORTING', status: 'ACTIVE' }}
                sort={{ field: 'name', order: 'ASC' }}
                perPage={-1}
                variant={variant}
                onChange={event => {
                  onCategoryChange(event.target.value, formProps);
                }}
              >
                <SelectInput optionText="name" validate={[myrequired]} />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              {hasSubcategories ? (
                <SelectInput
                  optionText="name"
                  source="subCategoryId"
                  choices={subcategories}
                  variant={variant}
                  label="Document Subcategory"
                />
              ) : (
                <></>
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <TextInput
                source="resourceUploadTitle"
                label="Batch Title"
                validate={[isFieldContainsOnlySpaces]}
                options={{
                  autoComplete: 'off',
                  label: (
                    <FieldTitleWithListPopover
                      source="Document"
                      label="Document Title"
                      onSelectItem={handleSelectVariableBatchTitle}
                      items={batchTitleVariables}
                      displayingVariables={true}
                    />
                  )
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.inputLabel
                  }
                }}
                variant={variant}
                inputRef={resourceUploadTitleRef}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <ReferenceInput
                label="Document Security"
                source="documentSecurityId"
                reference="documentsecurities"
                variant={variant}
                onChange={event => {
                  onSecurityChange(event.target.value, formProps);
                }}
              >
                <SelectInput optionText="description" validate={[required()]} />
              </ReferenceInput>
            </Grid>
            {hasWatermark ? (
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <ReferenceInput
                  reference="documentwatermarks"
                  source="watermarkProfileId"
                >
                  <WatermarkSelectInput variant={variant} />
                </ReferenceInput>
              </Grid>
            ) : (
              <Grid item xs={12} sm={12} md={6} lg={4}></Grid>
            )}
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <ReferenceInput
                label="Document Type"
                source="documentTypeId"
                reference="documenttypes"
                resource={resource}
                sort={{ field: 'description', order: 'ASC' }}
                perPage={-1}
                variant={variant}
                allowEmpty
              >
                <SelectInput optionText="description" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <RadioButtonGroupInput
                source="uploadType"
                label="Upload Type"
                options={{ row: true }}
                choices={[
                  { id: 'SINGLE', name: 'Single' },
                  { id: 'BULK', name: 'Bulk' }
                ]}
                validate={[required()]}
                variant={variant}
                margin="none"
                helperText={false}
                classes={{ label: classes.label }}
                onChange={value => {
                  onUploadTypeChange(value, formProps);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              {formProps &&
                formProps.values &&
                formProps.values.uploadType === 'BULK' && (
                  <ReferenceInput
                    label="Split Method"
                    source="splitMethodId"
                    reference="splitmethods"
                    variant={variant}
                    validate={[required()]}
                  >
                    <SelectInput optionText="name" validate={[required()]} />
                  </ReferenceInput>
                )}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <ReferenceInput
                label="Email Notification Template"
                source="templateId"
                reference="mailtemplates"
                allowEmpty
                variant={variant}
              >
                <SelectInput optionText="description" />
              </ReferenceInput>
            </Grid>
          </Grid>
        );
      }}
    </FormSpy>
  );
};

export default withStyles(styles)(PresetSummary);
